import { Theme } from "@mui/material";

function getSeriesColor(level: number, theme: Theme): string {
  return theme.palette.levelColors[level];
}

export default getSeriesColor;
